import React from 'react';

const ImageInput = ({ setLoadImage,setImage }) => {
  const handleImageChange = (e) => {
    const file = e.target.files[0];
    setImage(file);
    if (file && file.type.startsWith('image/')) {
      const reader = new FileReader();
      reader.onload = (e) => {
        setLoadImage(e.target.result);  // Envía la imagen al componente principal
      };
      reader.readAsDataURL(file);
    }
  };

  return (
    <div>
              <label className="block text-gray-700">Imagen del sorteo</label>
              <input type="file" accept="image/*" onChange={handleImageChange} className="p-2 mt-1 block w-full border border-gray-300 rounded-lg shadow-sm focus:ring focus:ring-indigo-200" required/>
    </div>
  );
};

export default ImageInput;
